"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Provider", {
  enumerable: true,
  get: function get() {
    return _Provider.default;
  }
});
Object.defineProperty(exports, "connectAdvanced", {
  enumerable: true,
  get: function get() {
    return _connectAdvanced.default;
  }
});
Object.defineProperty(exports, "ReactReduxContext", {
  enumerable: true,
  get: function get() {
    return _Context.ReactReduxContext;
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect.default;
  }
});
Object.defineProperty(exports, "useDispatch", {
  enumerable: true,
  get: function get() {
    return _useDispatch.useDispatch;
  }
});
Object.defineProperty(exports, "createDispatchHook", {
  enumerable: true,
  get: function get() {
    return _useDispatch.createDispatchHook;
  }
});
Object.defineProperty(exports, "useSelector", {
  enumerable: true,
  get: function get() {
    return _useSelector.useSelector;
  }
});
Object.defineProperty(exports, "createSelectorHook", {
  enumerable: true,
  get: function get() {
    return _useSelector.createSelectorHook;
  }
});
Object.defineProperty(exports, "useStore", {
  enumerable: true,
  get: function get() {
    return _useStore.useStore;
  }
});
Object.defineProperty(exports, "createStoreHook", {
  enumerable: true,
  get: function get() {
    return _useStore.createStoreHook;
  }
});
Object.defineProperty(exports, "batch", {
  enumerable: true,
  get: function get() {
    return _reactBatchedUpdates.unstable_batchedUpdates;
  }
});
Object.defineProperty(exports, "shallowEqual", {
  enumerable: true,
  get: function get() {
    return _shallowEqual.default;
  }
});

var _Provider = _interopRequireDefault(require("./components/Provider"));

var _connectAdvanced = _interopRequireDefault(require("./components/connectAdvanced"));

var _Context = require("./components/Context");

var _connect = _interopRequireDefault(require("./connect/connect"));

var _useDispatch = require("./hooks/useDispatch");

var _useSelector = require("./hooks/useSelector");

var _useStore = require("./hooks/useStore");

var _batch = require("./utils/batch");

var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");

var _shallowEqual = _interopRequireDefault(require("./utils/shallowEqual"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);